var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.932,
    height: 24.932,
    viewBox: "50.068 491.073 24.932 24.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.845 491.073H54.224a4.147 4.147 0 0 0-4.156 4.156v16.62a4.147 4.147 0 0 0 4.156 4.156h11.443a.983.983 0 0 0 .959-.959.983.983 0 0 0-.96-.959H54.225a2.265 2.265 0 0 1-2.238-2.237v-16.621c0-1.215 1.023-2.238 2.238-2.238h16.62a2.265 2.265 0 0 1 2.238 2.238v11.443c0 .511.448.959.96.959a.983.983 0 0 0 .958-.96V495.23a4.147 4.147 0 0 0-4.155-4.156Z",
    fill: "#ff5f15",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.502 496.827H58.635a.983.983 0 0 1-.96-.96c0-.51.448-.958.96-.958h10.867a.983.983 0 0 1 .96.959.983.983 0 0 1-.96.959Z",
    fill: "#ff5f15",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.502 500.598h-14.32a.983.983 0 0 1-.958-.958c0-.512.447-.96.958-.96h14.32a.983.983 0 0 1 .96.96.983.983 0 0 1-.96.958Z",
    fill: "#ff5f15",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.406 504.37h-7.224a.983.983 0 0 1-.958-.959.983.983 0 0 1 .958-.959h7.224a.983.983 0 0 1 .96.96.983.983 0 0 1-.96.958Z",
    fill: "#ff5f15",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.182 496.827a.983.983 0 0 1-.958-.96c0-.51.447-.958.958-.958.512 0 .96.447.96.959a.94.94 0 0 1-.797.946 1.055 1.055 0 0 1-.163.013Z",
    fill: "#ff5f15",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pencil",
    d: "m66.712 505.48-2.173-.064-.064 2.173 5.37 5.626c.502.502 1.25.511 1.76.089a1.367 1.367 0 0 0 .03-.025l.383-.32a1.295 1.295 0 0 0 .064-1.79l-5.37-5.69Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#ff5f15",
    fill: "transparent"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.c52bd24c.svg";
export { ForwardRef as ReactComponent };